import { render, staticRenderFns } from "./bread-crumbs.vue?vue&type=template&id=2a3cc877"
import script from "./bread-crumbs.vue?vue&type=script&lang=js"
export * from "./bread-crumbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports